import { NetworkError } from './network-error';
import { TimeoutError } from './timeout-error';

export function isRetryableError(error: unknown): boolean {
  return error instanceof NetworkError || error instanceof TimeoutError;
}
